import React from 'react';
import { useScrollProgress } from '../hooks/useReveal';

export const ScrollProgress = () => {
  const p = useScrollProgress();
  return (
    <div className="fixed top-0 left-0 right-0 h-[2px] z-[120] pointer-events-none">
      <div
        className="h-full origin-left"
        style={{
          transform: `scaleX(${p})`,
          background: 'linear-gradient(90deg, var(--brand), var(--accent), var(--mint))',
          transition: 'transform 80ms linear',
        }}
      />
    </div>
  );
};

export default ScrollProgress;
